import React, { Component } from "react";
import ShowValue from "../../components/ShowValue";

class AuctionList extends Component {
  render() {
    let lenght = this.props.auctionlist.length;
    let auctionList = this.props.auctionlist.slice(0, lenght > 9 ? 10 : lenght);

    return (
      <div className="pt-5 mt-5">
        <h2 className="asset-list">Auction List</h2>
        <hr />
        <ul className="list-unstyled list-formatted pl-0 ml-0">
          {auctionList.map((item, index) => (
            <li key={index} className="auction-list pb-1">
              <div className="row">
                <div className="col-md-6">
                  <span className="float-left">
                    {lenght - index}º - {item.name}
                  </span>
                </div>
                <div className="col-md-6">
                  <ShowValue className="float-right" btc={item.value} />
                </div>
              </div>
            </li>
          ))}
          <li
            className="auction-list"
            hidden={this.props.auctionlist.length > 0}
          >
            Be the first to Offer to
            <h3>
              Cryptolands.i
              <img src="/assets/images/sun.jpg" alt="sun" width="22" />
            </h3>
          </li>
        </ul>
      </div>
    );
  }
}

export default AuctionList;



// WEBPACK FOOTER //
// ./src/containers/AssetPage/auction-list.js